import * as React from 'react';

import { CMIC_TREE_NODE_TYPES, CMIC_STATIC_TREE_NODE_ID } from '../../shared/Constants';
import { filterOptionsFormatter } from './helper/FliterHelper';
import CustomCell from '../../components/common/customCell/CustomCell';
import customIconCell from '../../components/customIconCell';

const columnProps = {
	editable: false,
	renderCell: params => <CustomCell params={params} />,
	headerClassName: 'super-app-theme--header',
	headerAlign: 'left',
	sortable: false,
	filterable: false,
};

const iconProps = {
	headerName: '',
	// renderHeader: () => (
	//   <Icon iconName='FabricFormLibraryMirrored' />
	// ),
	renderCell: params => customIconCell(params),
};
// const primaryTextStyle={color: isBGClrDark() ? COLORS.OUTLOOK_LIGHT_BLUE: COLORS.OUTLOOK_DARK_BLUE ,padding:'0 0.1rem 0 0'}
const primaryTextStyle = { padding: '0 0.1rem 0 0' };
const definedGridColumns = (type, statusData, handleCellPress) => {
	switch (type) {
		case CMIC_STATIC_TREE_NODE_ID.START_NODE:
		case CMIC_STATIC_TREE_NODE_ID.CMIC_ECM:
			return [
				{
					field: type,
					headerName: 'Icon',
					width: 100,
					hideable: false,
					...columnProps,
					...iconProps,
				},
				{
					field: type,
					headerName: 'Name',
					width: 150,
					// renderHeader: () => (
					//   <strong style={{alignSelf:'center', backgroundColor:'red', textAlign:'center',width:'100%'}} >
					//     {'Birthday '}
					//     <span role="img" aria-label="enjoy">
					//       🎂🎂
					//     </span>
					//   </strong>
					// ),
					...columnProps,
				},
			];
		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT:
			return [
				{
					field: 'ImgdtDocumentTypeDesc',
					headerName: 'Name',
					// width: 280,
					flex: 1,
					hideable: false,
					...columnProps,
					sortable: true,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'count',
					headerName: 'Contents',
					// width: 80,
					flex: 0.5,
					...columnProps,
					sortable: true,
					headerAlign: 'right',
				},
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS:
		case CMIC_TREE_NODE_TYPES.PROJECT:
			return [
				{
					field: type,
					minWidth: 30,
					flex: 0.3,
					...columnProps,
					...iconProps,
				},
				{
					field: 'PmdgtTypeName',
					headerName: 'Name',
					minWidth: 150,
					flex: 5,
					hideable: false,
					...columnProps,
					sortable: true,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'count',
					headerName: 'Count',
					minWidth: 90,
					flex: 1,
					...columnProps,
					sortable: true,
					headerAlign: 'right',
					renderCell: params => <CustomCell params={params} alignment="end" />,
				},
			];
		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   minWidth: 40,
				//   flex:0.2,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				{
					field: type,
					flex: 0.2,
					...columnProps,
					...iconProps,
				},
				{
					field: 'ImgdDocumentName',
					headerName: 'Name',
					minWidth: 100,
					width: 200,
					flex: 4,
					hideable: false,
					...columnProps,
					sortable: true,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'createdOn',
					headerName: 'Created On',
					minWidth: 120,
					flex: 1,
					...columnProps,
					sortable: true,
				},
				// {
				//   field: "ImgdIuCreateUser",
				//   headerName: "Created By",
				//   minWidth: 120,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				// },
				// {
				//   field: "Size",
				//   headerName: "Size",
				//   width: 70,
				//   ...columnProps,
				// },
				// {
				//   field: "count",
				//   headerName: "Rev. No.",
				//   minWidth: 60,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				// },
			];

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
			return [
				{
					field: type,
					minWidth: 40,
					flex: 0.2,
					...columnProps,
					...iconProps,
				},
				{
					field: 'ImgrRevisionName',
					headerName: 'Name',
					minWidth: 60,
					width: 200,
					flex: 4,
					hideable: false,
					...columnProps,
					sortable: true,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'createdOn',
					headerName: 'Created On',
					minWidth: 105,
					flex: 1,
					...columnProps,
					sortable: true,
				},
				// {
				//   field: "ImgrIuCreateUser",
				//   headerName: "Created By",
				//   minWidth: 120,
				//   flex:0.5,
				//   ...columnProps,
				// },
				// {
				//   field: "Size",
				//   headerName: "Size",
				//   width: 70,
				//   ...columnProps,
				// },
				{
					field: 'ImgrRevisionNumber',
					headerName: 'Rev. No.',
					minWidth: 75,
					flex: 0.5,
					...columnProps,
					headerAlign: 'right',
					sortable: true,
					renderCell: params => <CustomCell params={params} alignment="end" />,
				},
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
			return [
				{
					field: type,
					minWidth: 30,
					flex: 0.2,
					...columnProps,
					...iconProps,
				},
				{
					field: 'PmdId',
					headerName: 'Document ID',
					minWidth: 138,
					maxWidth: 140,
					flex: 0.5,
					...columnProps,
					sortable: true,
					hideable: false,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'PmdTitle',
					headerName: 'Title',
					minWidth: 70,
					flex: 1.8,
					...columnProps,
					sortable: true,
					hideable: false,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'PmdRevDate',
					headerName: 'Revision Date',
					minWidth: 120,
					flex: 0.55,
					...columnProps,
					sortable: true,
				},
				// {
				//   field: "PmdRevNum",
				//   headerName: "Revision No.",
				//   minWidth: 50,
				//   flex:0.4,
				//   ...columnProps,
				//   sortable:true,
				//   renderCell:(params) => <CustomCell params={params} alignment='center' />,
				// },
				// {
				//   field: "Version",
				//   headerName: "Version",
				//   minWidth: 100,
				//   flex:0.5,
				//   ...columnProps,
				//   sortable:true,
				// },
				// {
				//   field: "PmdStatusCode",
				//   headerName: "Status",
				//   minWidth: 70,
				//   flex:0.4,
				//   ...columnProps,
				//   sortable:true,
				// },
				// {
				//   field: "Date Received",
				//   headerName: "Received Date",
				//   minWidth: 80,
				//   flex:0.4,
				//   ...columnProps,
				// },
				// {
				//   field: "revAttPath",
				//   headerName: "File Type",
				//   minWidth: 100,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='center' showFileType={true} />,
				// },
				// {
				//   field: "PmdLocationCode",
				//   headerName: "Location Code",
				//   minWidth: 100,
				//   flex:0.5,
				//   ...columnProps,
				//   sortable:true,
				// },
				// {
				//   field: "uploadedBy",
				//   headerName: "Uploaded By",
				//   minWidth: 120,
				//   flex:0.6,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' isName={true} />,
				// },
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE_REVISION:
			return [
				{
					field: type,
					minWidth: 40,
					flex: 0.2,
					...columnProps,
					...iconProps,
				},
				{
					field: 'PmdrDocId',
					headerName: 'Document Id',
					minWidth: 90,
					flex: 1,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'name',
					headerName: 'Name',
					minWidth: 80,
					flex: 1,
					...columnProps,
					hideable: false,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'PmdrRevDate',
					headerName: 'Revision Date',
					minWidth: 120,
					flex: 1,
					...columnProps,
				},
				{
					field: 'PmdrRevNum',
					headerName: 'Rev. No.',
					minWidth: 90,
					flex: 0.3,
					...columnProps,
				},
			];

		case CMIC_TREE_NODE_TYPES.DEFAULT:
		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT:
			return [
				{
					field: type,
					width: 100,
					...columnProps,
					...iconProps,
				},
				{
					field: 'Name',
					headerName: 'Name',
					width: 280,
					...columnProps,
					hideable: false,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'CreatedOn',
					headerName: 'Created On',
					width: 100,
					...columnProps,
				},
				{
					field: 'CreatedBy',
					headerName: 'Created By',
					width: 100,
					...columnProps,
				},
				{
					field: 'Size',
					headerName: 'Size',
					width: 70,
					...columnProps,
				},
				{
					field: 'RevNo',
					headerName: 'Rev. No.',
					width: 70,
					...columnProps,
				},
			];

		case CMIC_TREE_NODE_TYPES.PROJECTS_PARENT:
			return [
				{
					field: type,
					width: 100,
					...columnProps,
					...iconProps,
				},
				{
					field: 'Id',
					headerName: 'ID',
					width: 160,
					hideable: false,
					...columnProps,
				},
				{
					field: 'Name',
					headerName: 'Name',
					width: 280,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				// {
				//   field: "Count",
				//   headerName: "Count",
				//   width: 120,
				//   ...columnProps,
				// },
				{
					field: 'Code',
					headerName: 'Code',
					width: 120,
					...columnProps,
				},
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   width: 100,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				{
					field: 'Name',
					headerName: 'Name',
					width: 160,
					hideable: false,
					...columnProps,
				},
				{
					field: 'CommNo',
					headerName: 'Comm. No.',
					width: 100,
					...columnProps,
				},
				{
					field: 'Count',
					headerName: 'Message',
					width: 100,
					...columnProps,
				},
				{
					field: 'Count',
					headerName: 'Count',
					width: 100,
					...columnProps,
				},
				{
					field: 'ReceivedDate',
					headerName: 'Rec’d Date',
					width: 100,
					...columnProps,
				},
				// {
				//   field: "ReceivedStatus",
				//   headerName: "Rec’d Status",
				//   width: 100,
				//   editable: true,
				//   headerClassName: "super-app-theme--header",
				//   headerAlign: "left",
				// },
				{
					field: 'SubmitStatus',
					headerName: 'Status',
					width: 90,
					...columnProps,
				},
				{
					field: 'From',
					headerName: 'From',
					width: 130,
					...columnProps,
				},
				,
				// {
				//   field: "To",
				//   headerName: "To",
				//   width: 130,
				//   editable: true,
				//   headerClassName: "super-app-theme--header",
				//   headerAlign: "left",
				// }
				{
					field: 'Subject',
					headerName: 'Subject',
					width: 180,
					...columnProps,
				},
				{
					field: 'Message',
					headerName: 'Message',
					width: 180,
					...columnProps,
				},
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   minWidth: 40,
				//   flex:0.2,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				{
					field: 'PmjJournalId',
					headerName: 'Journal No.',
					minWidth: 138,
					maxWidth: 140,
					flex: 1,
					...columnProps,
					sortable: true,
					hideable: false,
					renderCell: params => (
						<CustomCell
							params={params}
							alignment="start"
							textStyle={primaryTextStyle}
							handleCellPress={handleCellPress}
						/>
					),
				},
				{
					field: 'PmjRecordStatus',
					headerName: 'Record Status',
					minWidth: 90,
					flex: 1,
					...columnProps,
					filterable: statusData?.PmjRecordStatus.length === 0 ? false : true,
					filterOperators: filterOptionsFormatter(statusData?.PmjRecordStatus),
					sortable: true,
				},
				{
					field: 'PmjDate',
					headerName: 'Date',
					minWidth: 110,
					maxWidth: 110,
					flex: 1,
					...columnProps,
					sortable: true,
				},
				// IMPLEMENTATION: Removed it's filter for now
				// {
				//   field: "PmjPrepContactName",
				//   headerName: "Prepared By",
				//   width: 120,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   // filterable: statusData?.PmjPrepContactName.length===0?false:true,
				//   // filterOperators: filterOptionsFormatter(statusData?.PmjPrepContactName),
				// },
				// {
				//   field: "PmjRainDayFlag",
				//   headerName: "Rainy Day",
				//   minWidth: 60,
				//   flex:0.2,
				//   ...columnProps,
				//   filterable: statusData?.PmjRainDayFlag.length===0?false:true,
				//   filterOperators: filterOptionsFormatter(statusData?.PmjRainDayFlag),
				//   sortable: true,
				// },

				// {
				//   field: "count",
				//   headerName: "Attachments",
				//   minWidth: 80,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='end' />,
				// },

				// {
				//   field: "PmjLowTemp",
				//   headerName: "Low Temp",
				//   minWidth: 60,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   sortable: true,
				// },
				// {
				//   field: "PmjHighTemp",
				//   headerName: "High Temp",
				//   minWidth: 60,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   sortable: true,
				// },
				// {
				//   field: "PmjPrecipitation",
				//   headerName: "Precipitation",
				//   minWidth: 60,
				//   flex:1,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   sortable: true,
				// },
				// {
				//   field: "PmjSkyConditions",
				//   headerName: "Sky Cond.",
				//   minWidth: 100,
				//   flex:1,
				//   ...columnProps,
				//   sortable: true,
				// },
				// {
				//   field: "PmjWindConditions",
				//   headerName: "Wind Cond.",
				//   minWidth: 80,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='end' />,
				//   sortable: true,
				// },
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   minWidth: 40,
				//   flex:0.2,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				// {
				//   field: "DmiTitle",
				//   headerName: "Name",
				//   width: 100,
				//   ...columnProps,
				// },
				{
					field: 'DmiIssueId',
					headerName: 'Issue ID',
					minWidth: 138,
					maxWidth: 140,
					flex: 0.5,
					...columnProps,
					hideable: false,
					renderCell: params => (
						<CustomCell
							params={params}
							alignment="start"
							textStyle={primaryTextStyle}
							handleCellPress={handleCellPress}
						/>
					),
					sortable: true,
				},
				{
					field: 'DmiTitle',
					headerName: 'Subject',
					minWidth: 120,
					flex: 1,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
					sortable: true,
				},
				// {
				//   field: "DmiStatusDesc",
				//   headerName: "Status",
				//   minWidth: 100,
				//   flex:1,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   filterable: statusData?.DmiRecordStatus.length===0?false:true,
				//   filterOperators: filterOptionsFormatter(statusData?.DmiRecordStatus),
				//   sortable: true,
				// },
				// {
				//   field: "DmiPriorityDesc",
				//   headerName: "Severity",
				//   minWidth: 80,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   filterable: statusData?.DmiPriorityDesc.length===0?false:true,
				//   filterOperators: filterOptionsFormatter(statusData?.DmiPriorityDesc),
				//   sortable: true,
				// },
				// {
				//   field: "DmiTypeCode",
				//   headerName: "Type",
				//   minWidth: 80,
				//   flex:0.5,
				//   ...columnProps,
				//   filterable: statusData?.DmiTypeCode.length===0?false:true,
				//   filterOperators: filterOptionsFormatter(statusData?.DmiTypeCode),
				//   sortable: true,
				// },
				{
					field: 'DmiIuCreateDate',
					headerName: 'Created Date',
					minWidth: 110,
					maxWidth: 110,
					flex: 0.6,
					...columnProps,
					sortable: true,
				},
				// {
				//   field: "count",
				//   headerName: "Attachments",
				//   minWidth: 80,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='end' />,
				// },
				// {
				//   field: "DmiDescription",
				//   headerName: "Description",
				//   hide: true,
				//   minWidth: 180,
				//   flex:1,
				//   ...columnProps,
				// },
				// {
				//   field: "DmiContactName",
				//   headerName: "From",
				//   minWidth: 100,
				//   flex:1,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   sortable: true,
				// },
				// {
				//   field: "DmiRespContactName",
				//   headerName: "Responsibility",
				//   minWidth: 100,
				//   flex:1,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				//   sortable: true,
				// },
				// {
				//   field: "Responsibility",
				//   headerName: "Responsibility",
				//   width: 130,
				//   editable: true,
				//   headerClassName: "super-app-theme--header",
				//   headerAlign: "left",
				// },
				// {
				//   field: "To",
				//   headerName: "To",
				//   width: 130,
				//   editable: true,
				//   headerClassName: "super-app-theme--header",
				//   headerAlign: "left",
				// },
				// {
				//   field: "Description",
				//   headerName: "Description", // REMOVING COZ there's no such field in REST API response
				//   width: 250,
				//   ...columnProps,
				// }
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   minWidth: 50,
				//   flex:0.3,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				// {
				//   field: "PmscrfiSubject",
				//   headerName: "Name",
				//   width: 100,
				//   ...columnProps,
				// },
				{
					field: 'PmscrfiRfiId',
					headerName: 'RFI ID',
					minWidth: 138,
					maxWidth: 140,
					flex: 0.5,
					hide: false,
					...columnProps,
					sortable: true,
					hideable: false,
					renderCell: params => (
						<CustomCell
							params={params}
							alignment="start"
							textStyle={primaryTextStyle}
							handleCellPress={handleCellPress}
						/>
					),
				},
				// {
				//   field: "PmscrfiQuestion",
				//   headerName: "Question",
				//   minWidth: 160,
				//   flex:1,
				//   ...columnProps,
				//   hide: true,
				// },
				{
					field: 'PmscrfiSubject',
					headerName: 'Subject',
					minWidth: 120,
					flex: 1,
					...columnProps,
					sortable: true,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				// {
				//   field: "PmscrfiStatusDesc",
				//   headerName: "Status",
				//   minWidth: 80,
				//   flex: 0.5,
				//   ...columnProps,
				//   sortable: true,
				//   filterable: statusData?.PmscrfiStatusDesc.length===0?false:true,
				//   filterOperators: filterOptionsFormatter(statusData?.PmscrfiStatusDesc),
				// },
				{
					field: 'PmscrfiCreateDate',
					headerName: 'Created Date',
					minWidth: 110,
					maxWidth: 110,
					flex: 0.5,
					...columnProps,
					sortable: true,
				},
				// {
				//   field: "PmscrfiRequiredDate",
				//   headerName: "Required Date",
				//   minWidth: 100,
				//   flex:1,
				//   ...columnProps,
				//   sortable: true,
				// },
				// {
				//   field: "PmscrfiAnsweredDate",
				//   headerName: "Answered Date",
				//   minWidth: 100,
				//   flex:1,
				//   ...columnProps,
				//   sortable: true,
				// },
				// {
				//   field: "count",
				//   headerName: "Attachments",
				//   minWidth: 80,
				//   flex:0.3,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='end' />,
				// },
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_PCI:
			return [
				{
					field: 'CmmCode',
					headerName: 'PCI No.',
					minWidth: 138,
					maxWidth: 140,
					flex: 0.5,
					...columnProps,
					hideable: false,
					sortable: true,
				},
				{
					field: 'CmmName',
					headerName: 'Description',
					minWidth: 120,
					flex: 1,
					...columnProps,
					hideable: false,
					sortable: true,
				},
				{
					field: 'pciRefDate',
					headerName: 'Date',
					minWidth: 110,
					maxWidth: 110,
					flex: 0.5,
					...columnProps,
					hideable: false,
					sortable: true,
				},
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   width: 100,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				{
					field: 'Name',
					headerName: 'Name',
					width: 150,
					...columnProps,
					hideable: false,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'Count',
					headerName: 'Count',
					width: 130,
					...columnProps,
				},
				{
					field: 'Vendor',
					headerName: 'Vendor',
					width: 130,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'Status',
					headerName: 'Status',
					width: 80,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'Date',
					headerName: 'Date',
					width: 100,
					...columnProps,
				},
				{
					field: 'TotalPendingAmt',
					headerName: 'Pending Amt.(T)',
					width: 130,
					...columnProps,
				},
				{
					field: 'ContractAmt',
					headerName: 'Contract Amt.',
					width: 100,
					...columnProps,
				},
				{
					field: 'CurrentAmt',
					headerName: 'Current Amt.',
					width: 100,
					...columnProps,
				},
				{
					field: 'PostedAmt',
					headerName: 'Posted Amount',
					width: 100,
					...columnProps,
				},
				{
					field: 'PendingAmt',
					headerName: 'Pending Amount',
					width: 100,
					...columnProps,
				},
				{
					field: 'ContractCode',
					headerName: 'Contract #',
					width: 100,
					...columnProps,
				},
				{
					field: 'ToBePaid',
					headerName: 'To Be Paid',
					width: 90,
					...columnProps,
				},
				{
					field: 'Completed',
					headerName: 'Completed',
					width: 90,
					...columnProps,
				},
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS_CHANGE_ORDERS:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   width: 100,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				{
					field: 'Name',
					headerName: 'Name',
					width: 150,
					...columnProps,
					hideable: false,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'Count',
					headerName: 'Count',
					width: 100,
					...columnProps,
				},
				{
					field: 'Vendor',
					headerName: 'Vendor',
					width: 130,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'Status',
					headerName: 'Status',
					width: 80,
					...columnProps,
				},
				{
					field: 'Date',
					headerName: 'Date',
					width: 100,
					...columnProps,
				},
				{
					field: 'ContChngCode',
					headerName: 'Change Code',
					width: 130,
					...columnProps,
				},
				{
					field: 'ContractAmt',
					headerName: 'Contract Amt.',
					width: 100,
					...columnProps,
				},
				{
					field: 'PartnerCode',
					headerName: 'Partner Code',
					width: 100,
					...columnProps,
				},
				{
					field: 'ContractCode',
					headerName: 'Contract #',
					width: 140,
					...columnProps,
				},
				{
					field: 'JobCode',
					headerName: 'Job Code',
					width: 90,
					...columnProps,
				},
			];
		// IMPLEMENTATION: Removed sorting on SUBMITTALS because of API issue
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS:
			return [
				// {
				//   field: type,
				//   headerName: "Icon",
				//   minWidth: 50,
				//   flex:0.3,
				//   renderHeader: () => (
				//     <Icon iconName='FabricFormLibraryMirrored' />
				//   ),
				//   ...columnProps,
				//   renderCell:(params) => customIconCell(params),
				// },
				{
					field: 'PmsmSbmtId',
					headerName: 'Submittal #',
					minWidth: 138,
					maxwidth: 140,
					flex: 0.5,
					hideable: false,
					...columnProps,
					renderCell: params => (
						<CustomCell
							params={params}
							alignment="start"
							textStyle={primaryTextStyle}
							handleCellPress={handleCellPress}
						/>
					),
				},
				{
					field: 'PmsmSbmtName',
					headerName: 'Name',
					minWidth: 120,
					flex: 1,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				// {
				//   field: "PmsmRecFromPartnName",
				//   headerName: "Prepared By",
				//   width: 100,
				//   ...columnProps,
				// },
				// {
				//   field: "PmsmSbmtStatusName",
				//   headerName: "Status",
				//   minWidth: 80,
				//   flex:1,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='start' />,
				// },
				// {
				//   field: "PmsmTypeDesc",
				//   headerName: "Type",
				//   minWidth: 100,
				//   flex:1,
				//   ...columnProps,
				// },
				// {
				//   field: "count",
				//   headerName: "Attachments",
				//   minWidth: 80,
				//   flex:0.5,
				//   ...columnProps,
				//   renderCell:(params) => <CustomCell params={params} alignment='end' />,
				// },
				// {
				//   field: "User",
				//   headerName: "User",
				//   width: 80,
				//   ...columnProps,
				// },
				// {
				//   field: "Status",
				//   headerName: "Status",
				//   width: 100,
				//   ...columnProps,
				// },
				{
					field: 'PmsmIuCreateDate',
					headerName: 'Created Date',
					flex: 0.5,
					minWidth: 110,
					maxWidth: 110,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				// {
				//   field: "Comment",
				//   headerName: "Comment",
				//   width: 180,
				//   ...columnProps,
				// }
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_RFI:
		case CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
		case CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
			return [
				{
					field: type,
					minWidth: 40,
					flex: 0.2,
					hideable: false,
					...columnProps,
					...iconProps,
				},
				{
					field: 'SysrdDocTitle',
					headerName: 'Name',
					minWidth: 100,
					flex: 1,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				// {
				//   field: "Folder",
				//   headerName: "Folder",
				//   width: 120,
				//   ...columnProps,
				// },
				{
					field: 'SysrdDate',
					headerName: 'Created On',
					minWidth: 80,
					flex: 1,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'SysrdContactName',
					headerName: 'Created By',
					minWidth: 100,
					flex: 1,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'SysrdStatus',
					headerName: 'Status',
					minWidth: 100,
					flex: 1,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				// {
				//   field: "Size",
				//   headerName: "Size",
				//   width: 130,
				//   ...columnProps,
				// }
			];

		case CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
		case CMIC_TREE_NODE_TYPES.PROJECT_PCI:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
			return [
				{
					field: type,
					width: 100,
					hideable: false,
					...columnProps,
					...iconProps,
				},
				{
					field: 'Name',
					headerName: 'Name',
					width: 220,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'Folder',
					headerName: 'Folder',
					width: 120,
					...columnProps,
					renderCell: params => <CustomCell params={params} alignment="start" />,
				},
				{
					field: 'CreatedOn',
					headerName: 'Created On',
					width: 100,
					...columnProps,
				},
				{
					field: 'CreatedBy',
					headerName: 'Created By',
					width: 130,
					...columnProps,
				},
				{
					field: 'Size',
					headerName: 'Size',
					width: 130,
					...columnProps,
				},
			];
		default:
			return [];
	}
};

export default definedGridColumns;
